import type { ReactNode } from 'react'
import { Navigate } from 'react-router-dom'

import { FullPageLoader } from '@/components/ui/full-page-loader'
import { useAuth } from '@/features/auth'

import { paths } from './paths'

/** Keeps signed-in users out of the login screen. */
export function RequireGuest({ children }: { children: ReactNode }) {
  const { isAuthenticated, isLoading } = useAuth()

  if (isLoading) return <FullPageLoader label="Restoring your session…" />
  if (isAuthenticated) return <Navigate to={paths.dashboard} replace />

  return <>{children}</>
}
